import { render, staticRenderFns } from "./afasAddressInput.vue?vue&type=template&id=d33dc32e&"
import script from "./afasAddressInput.vue?vue&type=script&lang=js&"
export * from "./afasAddressInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports